import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'

export default {
    name: 'app-loader',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon
    },

    props: {
        isActive: { type: Boolean, default: true },
        page: { type: String, default: 'page-home' }
    },

    data() {
        return {
            percent: 0,
            scaleX: 0,
            activeIndexHome: 0
        }
    },

    created() {
        // Set up loading
        this.loading = {}
        this.loading.started = false
        this.loading.ended = false
        this.loading.toLoad = 0
        this.loading.loaded = 0
        this.loading.progress = 0

        // Listen to events
        this.eventHub.$on('app-loader:start-loading-asset', this.onStartLoadingAsset)
        this.eventHub.$on('app-loader:end-loading-asset', this.onEndLoadingAsset)
        this.eventHub.$on('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$on('page-home:onActiveIndexChange', this.onActiveIndexChange)
    },

    destroyed() {
        this.eventHub.$off('app-loader:start-loading-asset', this.onStartLoadingAsset)
        this.eventHub.$off('app-loader:end-loading-asset', this.onEndLoadingAsset)
        this.eventHub.$off('application:onEnterFrame', this.onEnterFrame)
        this.eventHub.$off('page-home:onActiveIndexChange', this.onActiveIndexChange)
    },

    methods: {
        onStartLoadingAsset() {
            this.loading.started = true
            this.loading.toLoad++
        },
        
        onEndLoadingAsset() {
            this.loading.loaded++
        },

        onEnterFrame() {
            if (this.loading.started && !this.loading.ended) {
                const progress = this.loading.loaded / this.loading.toLoad
                this.loading.progress += (progress - this.loading.progress) * 0.2
                
                if (this.loading.progress > 0.99) {
                    this.loading.progress = 1
                    this.loading.ended = true
                    this.eventHub.$emit('application:hide-loader')
                }
                
                this.percent = Math.round(this.loading.progress * 100)
            }
        },

        onActiveIndexChange(index) {
            this.activeIndexHome = index
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-loader/script.js